import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getBrand,
  getString,
} from '../../api/redux-watson/watson-config-selectors';
import MonitoredImage from '../core/common/MonitoredImage';
import { findKeyInObj } from '../../utils/objects';
import { replaceParams } from 'app/utils/strings';
import * as PropTypes from 'prop-types';
import withMatchesTablet from 'app/ui/core/common/withMatchesTablet';

function wrapFile(file) {
  if (file.indexOf('/') === -1) {
    return `${process.env.PUBLIC_URL}/${file}`;
  }
  return file;
}

class BrandedLogo extends Component {
  state = {
    rawWidth: 0,
    rawHeight: 0,
  };

  useTablet() {
    return this.props.mediaQueryMatches && !this.props.defaultOnly;
  }

  getLogoData() {
    const base = this.useTablet()
      ? this.props.logo.tablet
      : this.props.logo.default;
    return base || this.props.logo.default;
  }

  onImageLoaded = e => {
    this.setState({
      rawWidth: e.target.naturalWidth || e.target.offsetWidth,
      rawHeight: e.target.naturalHeight || e.target.offsetHeight,
    });
  };

  getWidth() {
    if (this.state.rawWidth === 0) {
      return undefined;
    }
    return this.state.rawWidth * this.getScale();
  }

  getHeight() {
    if (this.state.rawHeight === 0) {
      return undefined;
    }
    return this.state.rawHeight * this.getScale();
  }

  getScale() {
    if (this.state.rawHeight === 0) {
      return 1;
    }
    const expectedHeight = this.useTablet()
      ? this.props.tabletHeight
      : this.props.height;
    return expectedHeight / this.state.rawHeight;
  }

  render() {
    if (!this.props.logo) {
      return null;
    }

    const alt = replaceParams(this.props.altTemplate, {
      productName: this.props.logo.alt,
    });
    const base = this.getLogoData();

    return (
      <MonitoredImage
        className={this.props.className}
        src={wrapFile(base.file)}
        alt={alt}
        style={{
          display: 'block',
          position: 'relative',
          top: base.vOffset || 0,
          left: 0,
        }}
        width={this.getWidth()}
        height={this.getHeight()}
        onLoad={this.onImageLoaded}
      />
    );
  }
}

BrandedLogo.propTypes = {
  logo: PropTypes.any,
  className: PropTypes.string,
  defaultOnly: PropTypes.any,
  altTemplate: PropTypes.any,
};

BrandedLogo.defaultProps = { className: '' };

const mapStateToProps = (state, ownProps) => ({
  logo: findKeyInObj(getBrand(state), ownProps.logoKey),
  altTemplate: getString(state, 'common.productHome'),
});

export default connect(mapStateToProps)(withMatchesTablet(BrandedLogo));
